<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/l356OP/tc-custom/9781504052207.jpg?1718183630760" alt="This image is the cover for the book Symposium"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Symposium
      </h1>
      <p class="bookDescription body article font2">
        <b>A fascinating discussion on sex, gender, and human instincts by one of history’s greatest philosophers.</b><br/>  <br/> In the course of a lively drinking party, a group of Athenian intellectuals exchange views on desire. From their conversation emerges a series of subtle reflections on gender roles, sex in society, and basic human instincts. The debate precedes one great after another: Agathon, Aristodemus, Eryximachus, Pausanias, Aristophanes, and Socrates—all describing love in many possible permutations and combinations. The dialogue culminates in a radical challenge to conventional views by Plato’s mentor, Socrates, who advocates transcendence through spiritual love. <i>The Symposium</i> is a deft interweaving of different viewpoints and ideas about the nature of love.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Plato
      </h2>
      
      <p class="authorDescription body article">Plato (428&minus;348 BCE) was a philosopher and mathematician in ancient Greece. A student of Socrates and a teacher of Aristotle, his Academy was one of the first institutions of higher learning in the Western world. He is widely regarded as the father of modern philosophy.&#160;<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?434e4d31